import { Type } from 'class-transformer'

import { SkuBase } from './SkuBase'
import { Product } from './Product'
export { UnitOfMeasure } from './SkuBase'

export class Sku extends SkuBase {
  @Type(() => Product)
  product: Product = new Product()

  name: string = ''

  get productName() {
    return this.productNameOverride || this.product?.name;
  }
}
